import { call, put, takeLatest } from "redux-saga/effects";
import { doUserSetup } from "../../../com/userSetup";
import {
  userSetupSuccess,
  userSetupFailure,
  UserSetupPayload,
} from "../../action/userSetup";
import { USER_SETUP_REQUEST } from "../../actionTypes/userSetup";
import { API_CODES } from "../../../constants";

interface UserSetupRequestAction {
  type: string;
  payload: UserSetupPayload;
}

export function* handleUserSetup(
  action: UserSetupRequestAction
): Generator<unknown, void, any> {
  try {
    const response = yield call(doUserSetup, action.payload);

    if (
      response.status === API_CODES.SUCCESS_CODE ||
      response.status === "SUCCESS"
    ) {
      yield put(userSetupSuccess());
    } else {
      const errorMessage =
        response.statusinfo?.message || "User setup failed. Please try again.";
      yield put(userSetupFailure(errorMessage));
    }
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : "Please try again later";
    yield put(userSetupFailure(errorMessage));
  }
}

export function* userSetupSaga() {
  yield takeLatest(USER_SETUP_REQUEST, handleUserSetup);
}

